(() => {
  for (const gallery of document.querySelectorAll('[data-native-media-gallery]')) {
    if (gallery.dataset.ready) continue;
    gallery.dataset.ready = 'true';
    const stage = gallery.querySelector('[data-gallery-stage]');
    const slides = [...stage.querySelectorAll('[data-gallery-slide]')];
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-index]')];
    const dialog = gallery.querySelector('[data-gallery-dialog]');
    const viewer = gallery.querySelector('[data-gallery-viewer]');
    const positions = new Map();
    let current = 0;
    let opener;
    let suppressImageClickUntil = 0;
    if (!slides.length) continue;
    const rememberAndPause = () => {
      for (const video of slides[current].querySelectorAll('video')) {
        if (video.currentTime > 0) positions.set(current, video.currentTime);
        video.pause();
      }
      for (const video of viewer.querySelectorAll('video')) {
        if (video.currentTime > 0) positions.set(current, video.currentTime);
        video.pause();
      }
    };
    const restorePosition = container => {
      const video = container.querySelector('video');
      const time = positions.get(current);
      if (!video || !time) return;
      const restore = () => {
        try { video.currentTime = Math.min(time, video.duration || time); } catch {}
      };
      if (video.readyState > 0) restore();
      else video.addEventListener('loadedmetadata', restore, {once:true});
    };
    const playSelected = container => {
      const video = container.querySelector('video');
      if (!video || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      video.muted = true;
      video.play().catch(() => { /* The native play control remains available. */ });
    };
    const renderViewer = (autoplay = false) => {
      viewer.replaceChildren();
      const copy = slides[current].cloneNode(true);
      copy.hidden = false;
      for (const element of [copy, ...copy.querySelectorAll('[id]')]) element.removeAttribute('id');
      const imageButton = copy.querySelector('[data-gallery-open]');
      if (imageButton) imageButton.replaceWith(...imageButton.childNodes);
      viewer.append(copy);
      restorePosition(copy);
      if (autoplay) playSelected(copy);
    };
    const render = (autoplay = false) => {
      slides.forEach((slide, index) => { slide.hidden = index !== current; });
      thumbnails.forEach((button, index) => {
        if (index === current) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      const status = `${slides[current].dataset.mediaKind} ${current + 1} of ${slides.length}`;
      gallery.querySelector('[data-gallery-status]').textContent = status;
      gallery.querySelector('[data-gallery-viewer-status]').textContent = status;
      gallery.dataset.currentIndex = String(current);
      restorePosition(slides[current]);
      if (dialog.open) renderViewer(autoplay);
      else if (autoplay) playSelected(slides[current]);
      const list = gallery.querySelector('.ub-media-gallery__thumbnails');
      const thumb = thumbnails[current];
      list.scrollTo({left:thumb.offsetLeft-list.clientWidth/2+thumb.clientWidth/2,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    };
    const select = index => {
      const next = (index + slides.length) % slides.length;
      if (next === current) return;
      rememberAndPause();
      current = next;
      render(true);
    };
    gallery.querySelectorAll('[data-gallery-previous]').forEach(button => button.addEventListener('click', () => select(current - 1)));
    gallery.querySelectorAll('[data-gallery-next]').forEach(button => button.addEventListener('click', () => select(current + 1)));
    thumbnails.forEach(button => button.addEventListener('click', () => select(Number(button.dataset.galleryIndex))));
    gallery.querySelectorAll('[data-gallery-open]').forEach(button => button.addEventListener('click', () => {
      if (performance.now() < suppressImageClickUntil) return;
      opener = button;
      const playing = [...slides[current].querySelectorAll('video')].some(video => !video.paused);
      rememberAndPause();
      dialog.showModal();
      renderViewer(playing);
    }));
    gallery.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      rememberAndPause();
      viewer.replaceChildren();
      restorePosition(slides[current]);
      const returnTo = opener?.isConnected && opener.getClientRects().length
        ? opener : gallery.querySelector('.ub-media-expand');
      returnTo.focus({preventScroll:true});
    });
    matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', event => {
      if (event.matches) rememberAndPause();
    });
    document.addEventListener('visibilitychange', () => { if (document.hidden) rememberAndPause(); });
    gallery.addEventListener('keydown', event => {
      if (event.altKey || event.ctrlKey || event.metaKey || event.target.closest('video,input,textarea,select')) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); select(current - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); select(current + 1); }
      if (event.key === 'Home') { event.preventDefault(); select(0); }
      if (event.key === 'End') { event.preventDefault(); select(slides.length - 1); }
    });
    for (const surface of [stage, viewer]) {
      let start;
      surface.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' || event.target.closest('video,iframe,.ub-media-arrow')) return;
        start = {x:event.clientX,y:event.clientY};
      }, {passive:true});
      surface.addEventListener('pointercancel', () => { start = undefined; });
      surface.addEventListener('pointerup', event => {
        if (!start) return;
        const dx=event.clientX-start.x,dy=event.clientY-start.y;
        start=undefined;
        if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)*1.3) return;
        if (surface === stage) suppressImageClickUntil = performance.now() + 400;
        select(current + (dx < 0 ? 1 : -1));
      }, {passive:true});
    }
    render();
  }
})();
